export default __webpack_public_path__ + "static/s-series-grout-scrub-deck-illustration-e668dc7a9b89b80f201cc770ca7313ec.png";